import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
//components
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import Select from '../../../components/Select';
//icons
import { FaProjectDiagram } from 'react-icons/fa';
//services
import { ProyectManagerService } from '../../../services/ProyectManagerService';
//toast
import { toastError, toastSuccess } from '../../../utils/toast';
//validations
import { validateRequired, validateMinLength, validateMaxLength, validateEmail } from '../../../utils/validations';

const AddProyectManager = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isEdit, proyectEdit } = location.state || { isEdit: false, proyectEdit: null };
  const [proyectTypes, setProyectTypes] = useState([]);
  const [proyect, setProyect] = useState({
    name: '',
    email: '',
  });
  const [errors, setErrors] = useState({
    name: '',
    email: '',
  });

  useEffect(() => {
    if (isEdit && proyectEdit) {
      setProyect({
        name: proyectEdit.name,
        email: proyectEdit.email,
      });
    }
  }, [isEdit, proyectEdit]);

  const validateNameField = () => {
    let error = validateRequired(proyect.name) 
    || validateMinLength(proyect.name, 3, 'El nombre debe tener al menos 3 caracteres') 
    || validateMaxLength(proyect.name, 100, 'El nombre debe tener menos de 100 caracteres');
    setErrors(prev => ({ ...prev, name: error || '' }));
    return !error;
  };

  const validateEmailField = () => {
    let error = validateRequired(proyect.email) 
    || validateMinLength(proyect.email, 3, 'El email debe tener al menos 3 caracteres') 
    || validateMaxLength(proyect.email, 100, 'El email debe tener menos de 100 caracteres')
    || validateEmail(proyect.email, 'El email debe ser válido');
    setErrors(prev => ({ ...prev, email: error || '' }));
    return !error;
  };

  const validateForm = () => {
    const isNameValid = validateNameField();
    const isEmailValid = validateEmailField();
    return isNameValid && isEmailValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      toastError('Por favor, complete todos los campos requeridos correctamente');
      return;
    }

    try {
      await ProyectManagerService.createProyect(proyect);
      toastSuccess('Proyecto agregado correctamente');
      navigate('/proyect_manager');
    } catch (error) {
      toastError('Error al agregar el proyecto');
    }
  };

  const handleEdit = async () => {
    if (!validateForm()) {
      toastError('Por favor, complete todos los campos requeridos correctamente');
      return;
    }
    
    try {
      await ProyectManagerService.updateProyect(proyectEdit.id, proyect);
      toastSuccess('Proyecto editado correctamente');
      navigate('/proyect_manager');
    } catch (error) {
      toastError('Error al editar el proyecto');
    }
  };

  return (
     <div className="bg-surface-card border border-white/[0.06] rounded-xl p-6">
      <h2 className="text-2xl font-bold mb-4">{isEdit ? 'Editar Proyecto' : 'Agregar Proyecto'}</h2>
      <div className="flex items-center gap-4 mt-10">
        <Input
          label="Nombre del manager"
          name="name"
          type="text"
          required
          size='lg'
          value={proyect.name}
          leftIcon={<FaProjectDiagram />}
          onChange={(e) => {
            setProyect({ ...proyect, name: e.target.value });
            validateNameField();
          }}
          error={errors.name}
        />
        <Input
          label="Email del manager"
          name="email"
          type="text"
          required
          size='lg'
          value={proyect.email}
          leftIcon={<FaProjectDiagram />}
          onChange={(e) => {
            setProyect({ ...proyect, email: e.target.value });
            validateEmailField();
          }}
          error={errors.email}
        />
      </div>
      <div className="flex justify-end mt-10 gap-6">
        <Button
          variant="warning"
          onClick={() => navigate('/proyect_manager')}
          className='w-[20%] h-[40px] rounded-[20px]'
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={isEdit ? handleEdit : handleSubmit}
          className='w-[20%] h-[40px] rounded-[20px]'
        >
          {isEdit ? 'Guardar cambios' : 'Guardar'}
        </Button>
      </div>
    </div>
  )
}

export default AddProyectManager
